import { NavLink } from 'react-router-dom';
import { routeConstants } from 'shared/constants';

const ProfileMenuItems = () => {
  const { ACCOUNT } = routeConstants;

  return (
    <>
      <ul className="profile_side_menu_list">
        <li className="profile_sidebar_menu">
          <a href="/" onClick={(e) => e.preventDefault()}>
            <img
              src={
                require('assets/images/profile_images/user_pink.png').default
              }
              className="img-responsive"
              alt="userimage"
            />
            <b>Account settings</b>
          </a>
        </li>
        <ul className="profile_sub_menu">
          <li>
            <NavLink to={ACCOUNT.subRoutes.PROFILE.path}>
              Profile Information
            </NavLink>
          </li>
          <li>
            <NavLink to={ACCOUNT.subRoutes.ADDRESSES.path}>
              Manage Address
            </NavLink>
          </li>
          <li>
            <NavLink to={ACCOUNT.subRoutes.BUSINESS_INFO.path}>
              Business Information
            </NavLink>
          </li>
        </ul>
      </ul>
      <ul className="profile_side_menu_list">
        <li className="profile_sidebar_menu">
          <NavLink
            to={ACCOUNT.subRoutes.MANAGE_ORDERS.path}
            activeClassName="actv_menu_heading active"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              version={1.0}
              width="15.000000pt"
              height="17.000000pt"
              viewBox="0 0 15.000000 17.000000"
              preserveAspectRatio="xMidYMid meet"
            >
              <g
                transform="translate(0.000000,17.000000) scale(0.100000,-0.100000)"
                fill="#000000"
                stroke="none"
              >
                <path d="M30 160 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z" />
                <path d="M100 160 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z" />
                <path d="M10 76 l0 -76 63 0 c35 0 66 2 68 4 2 2 2 36 1 76 -3 58 -6 69 -17 60 -10 -8 -19 -8 -33 1 -16 10 -23 10 -36 0 -13 -11 -19 -11 -31 -1 -13 11 -15 3 -15 -64z m110 34 c0 -5 -20 -10 -45 -10 -25 0 -45 5 -45 10 0 6 20 10 45 10 25 0 45 -4 45 -10z m5 -40 c-8 -13 -95 -13 -95 0 0 6 23 10 51 10 31 0 48 -4 44 -10z m-5 -30 c0 -5 -20 -10 -45 -10 -25 0 -45 5 -45 10 0 6 20 10 45 10 25 0 45 -4 45 -10z" />
              </g>
            </svg>
            <b>my orders</b>
          </NavLink>
        </li>
      </ul>
      <ul className="profile_side_menu_list">
        <li className="profile_sidebar_menu">
          <a href="/" onClick={(e) => e.preventDefault()}>
            <img
              src={
                require('assets/images/profile_images/user_pink.png').default
              }
              className="img-responsive"
              alt="userimage"
            />
            <b>my stuff</b>
          </a>
        </li>
        <ul className="profile_sub_menu">
          <li>
            <NavLink to={ACCOUNT.subRoutes.WISHLIST.path}>My Wishlist</NavLink>
          </li>
          <li>
            <NavLink to={ACCOUNT.subRoutes.MY_REVIEWS.path}>My Reviews</NavLink>
          </li>
        </ul>
      </ul>
    </>
  );
};

export default ProfileMenuItems;
